import { aludraApi } from 'api/axios'
import { mdl06Urls } from './mdl06.urls'

export const searchPromotion = async payload => {
  return aludraApi.post(mdl06Urls.promotion, payload)
}
